export enum CardTask {
    FOLD = 'fold',
    MATCH = 'match',
    FLIP = 'flip',
    WIGGLE = 'wiggle',
    ZAP = 'zap',
    BOOM = 'boom',
    BOMB = 'bomb',
    ICE = 'ice',
    CRAB = 'crab',
    KEY = 'key',
    PLUS_THREE = 'plus_three',
    PLUS_FIVE = 'plus_five',
    PLUS_STREAK = 'plus_streak',
    TORNADO = 'tornado',
    FOG_END = 'fog_end',
    ANCHOR = 'anchor',
    UNDO_MATCH = 'undo_match',
    UNDO_FOLD = 'undo_fold',
    TNT = 'tnt',
    BULLS_EYE = 'bulls_eye',
    SHUFFLE = 'shuffle',
    JOKER = 'joker',
}
